class DetailsDisclosure extends HTMLElement {
  constructor() {
    super();
    this.mainDetailsToggle = this.querySelector('details');
    this.content = this.mainDetailsToggle.querySelector('summary').nextElementSibling;

    this.mainDetailsToggle.addEventListener('focusout', this.onFocusOut.bind(this));
    this.mainDetailsToggle.addEventListener('toggle', this.onToggle.bind(this));
  }

  onFocusOut() {
    setTimeout(() => {
      if (!this.contains(document.activeElement)) this.close();
    });
  }

  onToggle() {
    if (!this.animations) this.animations = this.content.getAnimations();

    if (this.mainDetailsToggle.hasAttribute('open')) {
      this.animations.forEach((animation) => animation.play());
    } else {
      this.animations.forEach((animation) => animation.cancel());
    }
  }

  close() {
    this.mainDetailsToggle.removeAttribute('open');
    this.mainDetailsToggle.querySelector('summary').setAttribute('aria-expanded', false);
  }
}

customElements.define('details-disclosure', DetailsDisclosure);

class HeaderMenu extends DetailsDisclosure {
  constructor() {
    super();
    this.header = document.querySelector('.header-wrapper');

    // Con mouse: el desplegable abre al pasar por encima y el nombre del grupo es un enlace a su colección.
    // En pantallas táctiles el clic sigue abriendo/cerrando la lista (sin hover no habría cómo verla).
    this.hoverQuery = window.matchMedia('(hover: hover) and (pointer: fine)');
    this.summary = this.mainDetailsToggle.querySelector('summary');

    this.addEventListener('mouseenter', () => {
      if (!this.hoverQuery.matches) return;
      clearTimeout(this.closeTimer);
      this.mainDetailsToggle.setAttribute('open', '');
      this.summary.setAttribute('aria-expanded', true);
    });

    this.addEventListener('mouseleave', () => {
      if (!this.hoverQuery.matches) return;
      this.closeTimer = setTimeout(() => this.close(), 180);
    });

    this.summary.querySelector('.header__menu-link')?.addEventListener('click', (event) => {
      if (this.hoverQuery.matches) return;
      event.preventDefault();
      this.mainDetailsToggle.toggleAttribute('open');
    });
  }

  onToggle() {
    if (!this.header) return;
    this.header.preventHide = this.mainDetailsToggle.open;

    if (document.documentElement.style.getPropertyValue('--header-bottom-position-desktop') !== '') return;
    document.documentElement.style.setProperty(
      '--header-bottom-position-desktop',
      `${Math.floor(this.header.getBoundingClientRect().bottom)}px`
    );
  }
}

customElements.define('header-menu', HeaderMenu);
